module.exports = __webpack_public_path__ + "img/pay.9972045f.svg";